module.exports = __webpack_public_path__ + "img/store.6c68c1ec.svg";